"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "lanzada": {
    "8ec52b40": [{
      "hkey": "3fb097c6",
      "slug": "lanzada",
      "name": "Lanzada",
      "primary": true,
      "skipSearch": false
    }],
    "centro": [{
      "hkey": "3fb097c6",
      "slug": "lanzada",
      "name": "Lanzada",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7b711b6b": [{
      "hkey": "3fb097c6",
      "slug": "lanzada",
      "name": "Lanzada",
      "primary": true,
      "skipSearch": false
    }],
    "ganda": [{
      "hkey": "3fb097c6",
      "slug": "lanzada",
      "name": "Lanzada",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8eeaac57": [{
      "hkey": "3fb097c6",
      "slug": "lanzada",
      "name": "Lanzada",
      "primary": true,
      "skipSearch": false
    }],
    "moizi": [{
      "hkey": "3fb097c6",
      "slug": "lanzada",
      "name": "Lanzada",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b7e3acd1": [{
      "hkey": "3fb097c6",
      "slug": "lanzada",
      "name": "Lanzada",
      "primary": true,
      "skipSearch": false
    }],
    "tornadri": [{
      "hkey": "3fb097c6",
      "slug": "lanzada",
      "name": "Lanzada",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7f0cf7c4": [{
      "hkey": "3fb097c6",
      "slug": "lanzada",
      "name": "Lanzada",
      "primary": true,
      "skipSearch": false
    }],
    "vetto": [{
      "hkey": "3fb097c6",
      "slug": "lanzada",
      "name": "Lanzada",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;